import {IPresenter} from "../../../../../packages/RawDogJS/src/interfaces/IPresenter";
import {HelloWorldView} from "./helloWorldView";
import {Router} from "../../../../../packages/RawDogJS/src/router";
import {ParcelDependencyContainer} from "../../../../../packages/RawDogJS/src/core/ParcelDependencyContainer";

export class HelloWorldPresenter implements IPresenter{
    
    _view: any;
    private _dependencyContainer: ParcelDependencyContainer;
    private _router: Router;

    constructor(helloWorldView: HelloWorldView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = helloWorldView;        
        this._dependencyContainer = dependencyContainer;
        this._router = router;
    }
    
    
    public async post(){
        this._view.message = "What a lovely day " + this._view.fullName + "!";
    }

    initialize() {
        
        this._view.addOnClickHandler('#post-button',async ()=>{
            await this.post();
        })
        
    }

    inject() {
    }
    
    
    
}